import { ROUTE_PREFIX } from '@partment/types'

export function stripRolePrefix(path: string) {
  for (const prefix of Object.values(ROUTE_PREFIX)) {
    if (path.startsWith(prefix)) {
      return path.replace(prefix, '') || '/'
    }
  }
  return path
}
